import QuestionsAndAnswers from './QuestionsAndAnswers.page';

export default QuestionsAndAnswers;